
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/loyalty/createAccount/activateAccountChallenge",
      function () {
        return require("private-next-pages/loyalty/createAccount/activateAccountChallenge/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/loyalty/createAccount/activateAccountChallenge"])
      });
    }
  